import React from 'react'

const UserRoleTableRow = ({ userRoleData = [], onRowClick, selectedRow }) => {
  if (!userRoleData || userRoleData.length === 0) {
    return (
      <div className="user-table--row">
        <div className="user-table--cell fixed">
          <p>No data available</p>
        </div>
      </div>
    );
  }

  return (
    <>
      {userRoleData.map((row) => (
        <div 
          key={row.id} 
          className={`user-table--row ${selectedRow && selectedRow.id === row.id ? 'active' : ''}`}
          onClick={() => onRowClick && onRowClick(row)}
          style={{ cursor: 'pointer' }}
        >
          <div className="user-table--cell fixed" data-attr="Title">
            <p className="title">{row.title}</p>
          </div>
          <div className="detail-block">
          <div className="user-table--cell" data-attr="Assigned By">
            <p>{row.assignedBy}</p>
          </div>
          <div className="user-table--cell" data-attr="Execution date">
            <p>{row.executionDate}</p>
          </div>
          <div className="user-table--cell" data-attr="Deadline date">
            <p>{row.deadlineDate}</p>
          </div>
          </div>
          
        </div>
      ))}
    </>
  )
}
export default UserRoleTableRow;
